// @ts-strict-ignore
import { UserVO } from '@user/model/vo/user.vo';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { ProjectStatesDef } from '@project/components/project/constants/project-states-def';
import { NumberUtils } from '@shared/util/number-utils';
import { CommonUtils } from '@shared/util/common.utils';

export class ProjectOrderingUtils {
  public static isWriteProtected(projectHead: ProjectHeadVO, user: UserVO): boolean {
    if (!projectHead) {
      return false;
    }
    if (!user) {
      return true;
    }
    if (projectHead.isSharedReadOnly) {
      return true;
    }
    if (!projectHead.isLatestVersion) {
      return true;
    }
    if (user.hasPermission("SAVE_PDM_EXPORTED_PROJECTS")) {
      if (projectHead.finalizationState === ProjectStatesDef.FINALIZATION_STATE_PDM_EXPORT_DONE
        || projectHead.finalizationState === ProjectStatesDef.FINALIZATION_STATE_LEGACY_PROJECT_EXPORT_DONE
        || projectHead.finalizationState === ProjectStatesDef.FINALIZATION_STATE_FINALIZED_WITHOUT_PDM) {
        return false;
      }
    }
    return true;
  }

  public static isReleasedForProductionState(state: number): boolean {
    return state === ProjectStatesDef.FINALIZATION_STATE_PDM_EXPORT_DONE
      || state === ProjectStatesDef.FINALIZATION_STATE_LEGACY_PROJECT_EXPORT_DONE
      || state === ProjectStatesDef.FINALIZATION_STATE_FINALIZED_WITHOUT_PDM;
  }

  public static canCreateNewVersion(project: ProjectHeadVO, user: UserVO): boolean {
    if (!project || project.isSharedReadOnly) {
      return false;
    }
    if ((project.finalizationState ?? -1) > ProjectStatesDef.FINALIZATION_STATE_NEW &&
      user.hasPermission("SAVE_BLOCKED_PROJECTS_AS_NEW_VERSION")) {
      return true;
    }
    if (project.finalizationState === ProjectStatesDef.FINALIZATION_STATE_NEW
      && user.hasPermission("SAVE_UNBLOCKED_PROJECTS_AS_NEW_VERSION")) {
      return true;
    }
    return false;
  }

  public static isVersionLocked(projectHead: ProjectHeadVO, user: UserVO): Boolean {
    if (!projectHead) {
      return false;
    }
    if (projectHead.isSharedReadOnly) {
      return true;
    }
    if (!projectHead.isLatestVersion) {
      return true;
    }
    return (projectHead.finalizationState ?? -1) >= ProjectStatesDef.FINALIZATION_STATE_REQUESTED;
  }

  public static prepareDirectLink(projectHead: ProjectHeadVO): string | null {
    if (!projectHead) {
      return null;
    }
    return this.prepareDirectLinkByProjectIdAndSaveDateWithFallbackToProjectVersion(projectHead.id,
      projectHead.modificationDateServerTimeStamp, projectHead.currentVersion);
  }

  public static prepareDirectLinkByProjectIdAndSaveDateWithFallbackToProjectVersion(
    id: number, modificationDateServerTimeStamp: string, projectVersion: number): string {
    let link: string = CommonUtils.baseLocation() + '?function=loadproject&projectid=' + id;
    if (modificationDateServerTimeStamp) {
      link += '&date=' + modificationDateServerTimeStamp;
    } else if (NumberUtils.isNumber(projectVersion) && projectVersion > -1) {
      link += '&projectversion=' + projectVersion;
    }
    return link;
  }

  public static prepareProjectTemporaryLink(id: number, saveTimeStamp: string, projectVersion: number, guid: string): string {
    let link: string = this.prepareDirectLinkByProjectIdAndSaveDateWithFallbackToProjectVersion(id, saveTimeStamp, projectVersion);
    link += '&guid=' + guid;
    return link;
  }
}
